(ns common.schema.entity-type-search
  (:require [common.schema.entity-type-registry :as entity-type-registry]))

(defn definition->index-config
  [{:keys [entity-type search]}]
  (when-let [indexing (:indexing search)]
    [entity-type indexing]))

(def registry-index-configs
  (->> entity-type-registry/entity-type-definitions
       (keep definition->index-config)
       (into {})))

(defn registry-index-config
  [entity-type]
  (get registry-index-configs entity-type))
